import axios from './../axios';
import { toArrayQuery } from '@/plugins/toQuery';

export const getSupplier = async (id) => {
  try {
    const res = await axios.get(`/users/${id}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

export const getSupplierServices = async (id) => {
  try {
    const res = await axios.get(`/supplier_services/${id}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

export const getSupplierDetails = async (id) => {
  try {
    const res = await axios.get(`/supplier_details/${id}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

export const contactSupplier = async (payload) => {
  try {
    return await axios.post('/contact-supplier', payload);
  } catch (err) {
    console.error(err);
  }
};

export const getSuppliers = async (params) => {
  let arrayParams = toArrayQuery({
    service: params.service,
    location: params.location,
    specifications: params.specifications
  });
  try {
    return await axios.get(
      `/suppliers?keyword=${params.keyword}${encodeURIComponent(arrayParams)}`
    );
  } catch (err) {
    console.error(err);
  }
};

export const getContactedSuppliers = async () => {
  try {
    const res = await axios.get(`/contacted-suppliers`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};